/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Allocation_Schedules_InvalidInputs */

const en_error_allocation_schedules_invalid = /** @type {(inputs: Error_Allocation_Schedules_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The times of the warehouse are not valid.`)
};

/**
* | output |
* | --- |
* | "The times of the warehouse are not valid." |
*
* @param {Error_Allocation_Schedules_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_allocation_schedules_invalid = /** @type {((inputs?: Error_Allocation_Schedules_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Allocation_Schedules_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_allocation_schedules_invalid(inputs)
});